import React from 'react'
import { containerVariations } from './styles/styles.css'
import { cssClass } from '../../../shared/utils/styles'

interface Props {
  children: React.ReactNode | React.ReactNode[]
  variation?: keyof typeof containerVariations
  className?: string[]
  dataTestId?: string
}

export const ContainerComponent: React.FC<Props> = ({
  children,
  variation = 'default',
  className = [''],
  dataTestId = null,
}) => {
  return (
    <section
      className={cssClass([containerVariations[variation], ...className])}
      data-testid={dataTestId}
    >
      {children}
    </section>
  )
}
